var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAttend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "person_off_FILL0_wght400_GRAD0_opsz48",
    d: "M31.427,35.2l-3.736-3.736H6.786V27.917A4.153,4.153,0,0,1,7.5,25.464a4.6,4.6,0,0,1,1.849-1.547,29.273,29.273,0,0,1,4.358-1.585,18.628,18.628,0,0,1,4.208-.642L3.05,6.823,4.673,5.2,33.05,33.577ZM9.05,29.2H25.427l-5.245-5.245a5.178,5.178,0,0,0-.642-.038h-.679a20.055,20.055,0,0,0-4.189.434,19.166,19.166,0,0,0-4.415,1.6A2.27,2.27,0,0,0,9.05,27.917Zm19.283-5.283a4.55,4.55,0,0,1,1.887,1.547,4.153,4.153,0,0,1,.717,2.453v.3l-5.4-5.4q.679.226,1.377.509T28.333,23.917ZM21.5,18.785l-1.811-1.811a3.228,3.228,0,0,0,1.849-1.17,3.467,3.467,0,0,0-.264-4.528,3.467,3.467,0,0,0-4.528-.264,3.228,3.228,0,0,0-1.17,1.849l-1.811-1.811a5.19,5.19,0,0,1,2.094-2.226,5.912,5.912,0,0,1,3-.792,5.605,5.605,0,0,1,5.66,5.66,5.912,5.912,0,0,1-.792,3A5.19,5.19,0,0,1,21.5,18.785ZM25.427,29.2h0ZM17.654,14.9Z",
    transform: "translate(-3.05 -5.2)",
    fill: "#f4f4f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttend);
export default __webpack_public_path__ + "static/media/noAttend.26f29247aee7bae0e5778872f1fab8cd.svg";
export { ForwardRef as ReactComponent };